import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c6d084"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-button" }
const _hoisted_2 = ["onClick"]

import {
  ref, watch, reactive, computed, withDefaults,
} from 'vue';
import { useRoute, useRouter, } from 'vue-router';
import { useStore, } from 'vuex';

import loginConfig from '@/configs/loginMenuConfigs';

interface Props {
  moduleName?: string,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    moduleName: { default: '' }
  },
  setup(__props: any) {

const props = __props as { moduleName: string }

const store = useStore();

// 后端返回的菜单
const userGrantList = computed(() => store.state.userCenter.userGrantList);

const route = useRoute();
const router = useRouter();



const state = reactive({
  name: route.name === '通报' || route.name === '处罚' ?
    '检查记录' :
    route.name,
});

watch(
  () => route,
  (newRoute) => {
    // 违规记录的tab选中状态跟name有关，所以把通报和处罚统一改成违规记录
    if (newRoute.name === '通报' || newRoute.name === '处罚') {
      state.name = '检查记录';
    } else {
      state.name = newRoute.name;
    }
  },
  {
    deep: true,
  }
);

const routerList = ref<Array<any>>([]);

/*
 * loginConfig.forEach((item: any) => {
 *   if (item.label === props.moduleName) {
 *     routerList = item.children;
 *   }
 * });
 */

const getRouterList = (data: any) => {
  data.forEach((item: any) => {
    if (item.name === props.moduleName) {
      routerList.value = item.children;
    }
  });
};

watch(() => userGrantList.value, (cur) => {
  getRouterList(cur);
});

getRouterList(userGrantList.value);

const jumped = (path: any): void => {
  router.push({
    path,
  });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerList.value, (item) => {
      return (_openBlock(), _createElementBlock("button", {
        class: _normalizeClass(["btn", item.name === _unref(state).name ? 'active' : '']),
        key: item.id,
        onClick: ($event: any) => (jumped(item.url))
      }, _toDisplayString(item.name), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})